import React from 'react';
import { ecoimpactContent } from '../rich-content/ecoimpact-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const EcoimpactDetailPage = () => {
  return <AutomaticPageBuilder content={ecoimpactContent} />;
};

export default EcoimpactDetailPage;
